import type { TermFormRow, TermType } from "../types";

// Client-side guard run on Save. An empty schedule is allowed. For percent
// terms every row must have a positive percentage AND the rows must total
// EXACTLY 100 (the server only enforces <= 100; we require == 100). For
// milestone terms every row must have a phase. Returns an error message to
// surface, or null when valid.
export const validateTerms = (
  termType: TermType,
  terms: TermFormRow[]
): string | null => {
  if (terms.length === 0) return null;

  if (termType === "percent") {
    if (terms.some((t) => t.percentageDue == null || t.percentageDue <= 0)) {
      return "Every percentage term must have a percentage greater than 0.";
    }
    const total = terms.reduce((sum, t) => sum + (t.percentageDue ?? 0), 0);
    if (total !== 100) {
      return `Payment term percentages must total exactly 100% (currently ${total}%).`;
    }
    return null;
  }

  if (terms.some((t) => t.phaseId == null)) {
    return "Every milestone term must have a phase selected.";
  }
  return null;
};

export default validateTerms;
